import config from 'appConfig';
import * as httpMethods from 'Api/Helpers/httpMethods';
import getHeaders from 'Api/Helpers/getHeaders';
import { JSON_MIME_TYPE } from 'Api/Helpers/requestProperties';
import { fetchJson } from 'Api/Helpers/fetch';

const URL_PREFIX = '/v1/products/';
const product = 'g2w';
const RECORDINGS_PATH = '/recordings/';
const URL_POSTFIX = '/chapters';

export function retrieveChapters(recordingId) {
  const url = `${config.chaptersService.url}${URL_PREFIX}${product}${RECORDINGS_PATH}${recordingId}${URL_POSTFIX}`;
  const options = {
    headers: getHeaders(true, 'Bearer'),
    method: httpMethods.GET
  };

  return fetchJson(url, options, JSON_MIME_TYPE);
}

export function deleteChapter(recordingId, chapterId) {
  const url = `${config.chaptersService.url}${URL_PREFIX}${product}${RECORDINGS_PATH}${recordingId}${URL_POSTFIX}/${chapterId}`;
  const options = {
    headers: getHeaders(true, 'Bearer'),
    method: httpMethods.DELETE
  };

  return fetchJson(url, options, JSON_MIME_TYPE);
}

export function updateChapters(recordingId, chapters) {
  const url = `${config.chaptersService.url}${URL_PREFIX}${product}${RECORDINGS_PATH}${recordingId}${URL_POSTFIX}`;
  const options = {
    headers: getHeaders(true, 'Bearer'),
    method: httpMethods.PUT,
    body: JSON.stringify(chapters)
  };

  return fetchJson(url, options, JSON_MIME_TYPE);
}
